/**
 * Pages enumeration mapping page identifiers to page components.
 * Central registry of all available pages in the application for routing purposes.
 */

import Account from '../../components/pages/settings/account';
import Addon from '../../components/pages/addon';
import BackDoor from '@components/pages/backDoor';
import Channels from '../../components/pages/channels';
import ChannelGuide from '../../components/pages/channelGuide';
import ChannelList from '../../components/pages/channelList';
import ClassicChannels from '@components/pages/classicChannels';
import Corner from '../../components/pages/corner';
import Detail from '../../components/pages/detail';
import DetailAddon from '../../components/pages/detailAddon';
import Disk from '../../components/pages/settings/disk';
import Empty from '../../components/pages/empty';
import Error from '../../components/pages/error';
import Exit from '../../components/pages/exit';
import IACorner from '@components/pages/iaCorner';
import Initial from '../../components/pages/initial';
import LanguagesSelection from '../../components/pages/access/language';
import Languages from '../../components/pages/settings/languages';
import LastShowsChannel from '../../components/pages/lastShowsChannel';
import Link from '../../components/pages/access/link';
import Logout from '../../components/pages/settings/logout';
import ManageChannels from '../../components/pages/settings/manageChannels';
import MoreContent from '../../components/pages/moreContent';
import Movies from '../../components/pages/moviesu7d';
import MySpace from '../../components/pages/mySpace';
import Player from '../../components/pages/player';
import PowerSaving from '../../components/pages/settings/powerSaving';
import Recordings from '../../components/pages/recordings';
import Search from '../../components/pages/search';
import SeasonExtended from '../../components/pages/seasonExtended';
import SeriesExtended from '../../components/pages/seriesExtended';
import SeriesU7D from '../../components/pages/seriesu7d';
import Settings from '../../components/pages/settings';
import ShowsU7D from '../../components/pages/showsu7d';
import SuccessfulLink from '../../components/pages/access/successfulLink';
import WatchEverything from '../../components/pages/watchEverything';
import Welcome from '../../components/pages/access/welcome';
import Zapper from '../../components/pages/zapper';
import { ChannelsChoice } from '@components/pages/channelsChoice';

/**
 * Pages object mapping page identifiers to their corresponding React components.
 * Used for routing and page navigation throughout the application.
 */
const Pages = {
  ACCOUNT: Account,
  ADDON: Addon,
  BACK_DOOR: BackDoor,
  CHANNEL_GUIDE: ChannelGuide,
  CHANNEL_LIST: ChannelList,
  CLASSIC_CHANNEL: ClassicChannels,
  CHANNELS_CHOICE: ChannelsChoice,
  CHANNELS_MAIN: Channels,
  CORNER: Corner,
  DETAIL: Detail,
  DETAIL_ADDON: DetailAddon,
  DISK: Disk,
  EMPTY: Empty,
  ERROR: Error,
  EXIT: Exit,
  IA_CORNER: IACorner,
  INITIAL: Initial,
  LANGUAGES: LanguagesSelection,
  LAST_SHOWS_CHANNEL: LastShowsChannel,
  LINK: Link,
  LOGOUT: Logout,
  MANAGE_CHANNELS: ManageChannels,
  MORE_CONTENT: MoreContent,
  MOVIES: Movies,
  MY_SPACE: MySpace,
  PLAYER: Player,
  RECORDINGS: Recordings,
  SEARCH: Search,
  SEASON_EXTENDED: SeasonExtended,
  SERIES_EXTENDED: SeriesExtended,
  SERIES_U7D: SeriesU7D,
  SETTINGS: Settings,
  SETTING_LANGUAGES: Languages,
  POWER_SAVING: PowerSaving,
  SHOWS_U7D: ShowsU7D,
  SUCCESSFUL_LINK: SuccessfulLink,
  WATCH_EVERYTHING: WatchEverything,
  WELCOME: Welcome,
  ZAPPER: Zapper,
};

export default Pages;
